import { RootState } from "../../store";

export const getUserMessagesList = (state: RootState) =>
  state.messagePopper.userMessagesList;
